let WIDTH = 768;
let HEIGHT = 1663;

// let DEVICE_PIXEL_RATIO = window.devicePixelRatio > 1 ? 2 : 1;
let DEVICE_PIXEL_RATIO = 1;
let RESOLUTION = DEVICE_PIXEL_RATIO > 1 ? '2x' : '1x';

const GRIZZ = 'grizz';
const ICE = 'ice';
const PANDA = 'panda';

const config = {
  MUSIC_ON: 'musicOn',
  SOUNDS_ON: 'soundsOn',
  MEDIA_LAYOUTS_PATH: './media/layouts/',
  MEDIA_IMAGE_PATH: './media/images/',
  MEDIA_AUDIO_PATH: './media/audio/',
  MEDIA_FONT_PATH: './media/fonts/',
  MEDIA_DATA_PATH: './media/data/',
  CONFIG_PATH: './',
  DEBUG_CHILDREN: 0,
  DEBUG_ADVERTISEMENT: 1,
  LOCAL_STORAGE_KEY: 'rumble-bee',
  DEVICE_PIXEL_RATIO: DEVICE_PIXEL_RATIO,
  RESOLUTION: RESOLUTION,
  SCALE: DEVICE_PIXEL_RATIO > 1 ? 0.5 : 1,
  WIDTH: WIDTH,
  HEIGHT: HEIGHT,
  CENTER_X: WIDTH / 2,
  CENTER_Y: HEIGHT / 2,
  ASPECT_RATIO: WIDTH / HEIGHT,
  BASE_SCENE: 'BASE_SCENE',
  BOARD_WIDTH: 14,
  BOARD_HEIGHT: 14,
  BEARS: [GRIZZ, ICE, PANDA],
  BEAR_HINT_INTERVAL: 10000,
  STARTING_COINS: 10,
  UNDO: 'undo',
  HINT: 'hint',
  BOMB: 'bomb',
  COST: {
    undo: 20,
    hint: 25,
    bomb: 10
  },
  POINTS: {
    MATCH: 50,
    BEAR: 150,
    COLLECTABLE: 25
  },
  COINS_PER_BOX: 1,
  COLLECTABLE_TOTAL: 15,
  LEVELS: {
    HTP: 'level-0',
    EASY: [
      'level-1',
      'level-2',
      'level-3'
      // 'level-4',
      // 'level-5',
      // 'level-6',
      // 'level-7',
      // 'level-8',
      // 'level-9'
    ],
    NORMAL: [
      'level-10',
      'level-11',
      'level-12',
      'level-13',
      'level-14',
      'level-15',
      'level-16',
      'level-17',
      'level-18',
      'level-19',
      'level-20',
      'level-21',
      'level-22',
      'level-23',
      'level-24',
      'level-25',
      'level-26',
      'level-27',
      'level-28',
      'level-29',
      'level-30',
      'level-31',
      'level-32',
      'level-33',
      'level-34',
      'level-35',
      'level-36',
      'level-37',
      'level-38',
      'level-39'
    ]
  }
};

export default config;
